import { render, staticRenderFns } from "./glWangEditor.vue?vue&type=template&id=2cc902d8&scoped=true"
import script from "./glWangEditor.vue?vue&type=script&lang=js"
export * from "./glWangEditor.vue?vue&type=script&lang=js"
import style0 from "./glWangEditor.vue?vue&type=style&index=0&id=2cc902d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc902d8",
  null
  
)

export default component.exports